<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome da gestante"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :item-class="getRowColor"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteEsusPecGlobal />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>

          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <!--   <template v-slot:item.id="{ item }">
            {{ item.id == null ? item.nu_cpf_cns : item.id }}
          </template> -->

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="6">
              <table
                class="table table-interna table-interna-exames-hiv-sifilis"
              >
                <thead>
                  <tr>
                    <th>CNS</th>
                    <th>CPF</th>
                    <th>TESTE HIV</th>
                    <th>SOROLOGIA HIV</th>
                    <th>TESTE SÍFILIS</th>
                    <th>SOROLOGIA SÍFILIS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <show-hide-field :value="item.nu_cns"></show-hide-field>
                    </td>
                    <td>
                      <show-hide-field :value="item.nu_cpf"></show-hide-field>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_ultimo_teste_hiv) }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_ultima_sorologia_hiv) }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_ultimo_teste_sifilis) }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_ultima_sorologia_sifilis) }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${this.printTableRow(
        item.dt_ultimo_teste_sifilis,
        item.dt_ultima_sorologia_sifilis,
        item.dt_ultimo_teste_hiv,
        item.dt_ultima_sorologia_hiv
      )}`
    },

    printTableRow(
      dt_ultimo_teste_sifilis,
      dt_ultima_sorologia_sifilis,
      dt_ultimo_teste_hiv,
      dt_ultima_sorologia_hiv
    ) {
      return Functions.printTableRow(
        dt_ultimo_teste_sifilis,
        dt_ultima_sorologia_sifilis,
        dt_ultimo_teste_hiv,
        dt_ultima_sorologia_hiv
      )
    },
  },
}
</script>

<style scoped lang="scss">
.table.table-interna-exames-hiv-sifilis {
  tbody {
    tr {
      td {
        vertical-align: text-top;
      }
    }
  }
}
.table-interna {
  width: 100%;
  margin: 25px auto;
  display: table;
  thead {
    tr {
      background-color: #f7f7f7;
      th {
      }
    }
  }
  tbody {
    tr {
      margin-bottom: 10px;
      td {
        span {
          font-size: 13px !important;
          color: #000 !important;
        }
      }
      td {
        ul {
          list-style-type: disc;
        }
      }
    }
  }
}
</style>
